import type { OrganizationPayload } from '@Application/Organizations/Organizations/Actions/organizationsFetched';

export type OrganizationUpdatedPayload = OrganizationPayload;

export type OrganizationUpdatedAction = {
	type: 'ORGANIZATION_UPDATED';
	payload: OrganizationUpdatedPayload;
	accountId: number;
};

export default (payload: OrganizationUpdatedPayload, accountId: number): OrganizationUpdatedAction => ({
	type: 'ORGANIZATION_UPDATED',
	payload,
	accountId,
});
